import React from 'react'
import { Link } from 'react-router-dom'
import { CallToAction } from '@scentregroup/ui'
import { PRODUCTS } from '../../paths'
import Footer from '../footer'
import NewsletterSubscribe from '../newsletter-subscribe'
import { CountryContext } from '../../context'
import style from './index.scss'

const NationalFooter = ({ ...restProps }) => (
  <CountryContext.Consumer>
    {country => (
      <Footer {...restProps}>
        {country === 'Australia' && (
          <div className={style.productButtonWrapper}>
            <CallToAction
              inverted
              fullWidth
              className={style.productButton}
              element={Link}
              to={PRODUCTS}
              data-test-id="products-button"
            >
              Products
            </CallToAction>
          </div>
        )}
        <NewsletterSubscribe country={country} />
      </Footer>
    )}
  </CountryContext.Consumer>
)

export default NationalFooter
